import type { ToastMessage } from '~/components/Toast';
import { HttpStatusCode } from '~settings/api/lib/types';

export const getDeleteMessageFromStatus = (status: HttpStatusCode) => {
  if (status === HttpStatusCode.Forbidden) {
    return {
      title: 'labelGroup.errors.forbidden.title',
      description: 'labelGroup.errors.forbidden.message',
    };
  }

  return {
    title: 'labelGroup.errors.generic.title',
    description: 'labelGroup.errors.generic.deleteMessage',
  };
};

export const getMessageFromStatus = (
  status: HttpStatusCode,
  isCreate = false,
): ToastMessage => {
  switch (status) {
    case HttpStatusCode.Forbidden:
      return {
        title: 'labelGroup.errors.forbidden.title',
        description: 'labelGroup.errors.forbidden.message',
      };
    case HttpStatusCode.BadRequest:
      return {
        title: 'labelGroup.errors.validation.title',
        description: 'labelGroup.errors.validation.message',
      };
    default:
      if (isCreate) {
        return {
          title: 'labelGroup.errors.generic.title',
          description: 'labelGroup.errors.generic.createMessage',
        };
      }

      return {
        title: 'labelGroup.errors.generic.title',
        description: 'labelGroup.errors.generic.editMessage',
      };
  }
};
